module.exports = __webpack_public_path__ + "static/Abacus Human Resources LEHMANNPARTNER-1828f17e5ab83951f06db2e418d82b25.pdf";